"use strict";
// _partialFile.js

// アコーディオン
document.addEventListener("DOMContentLoaded", () => {
  setUpAccordion();
  setUpCautionAccordion();
});

const setUpAccordion = () => {
  const details = document.querySelectorAll(".p-accordion__content");
  const IS_OPENED_CLASS = "is-opened";

  // アコーディオンを閉じる共通関数
  const closeAccordion = (targetElement) => {
    const targetContent = targetElement.querySelector(".p-accordion__contentBody");
    targetElement.classList.remove(IS_OPENED_CLASS);
    targetContent.style.height = targetContent.scrollHeight + "px";
    targetContent.offsetHeight; // 強制リフロー
    targetContent.style.height = "0";
    targetContent.style.opacity = "0";
    targetContent.addEventListener("transitionend", function handler(e) {
      if (e.propertyName === "height") {
        targetElement.removeAttribute("open");
        targetContent.removeEventListener("transitionend", handler);
      }
    });
  };

  details.forEach((element, index) => {
    const summary = element.querySelector(".p-accordion__contentHead");
    const content = element.querySelector(".p-accordion__contentBody");

    if (index === 0) {
      // 初期表示時のアニメーション（チラつき）を防ぐ
      const iconLines = element.querySelectorAll(".p-accordion__contentHeadIcon line");
      content.style.transition = "none";
      iconLines.forEach((line) => (line.style.transition = "none"));

      element.classList.add(IS_OPENED_CLASS);
      element.setAttribute("open", "true");
      content.style.height = "auto";
      content.style.opacity = "1";

      // トランジションを復帰（即時だと効かない場合があるためsetTimeoutを使用）
      setTimeout(() => {
        content.style.transition = "";
        iconLines.forEach((line) => (line.style.transition = ""));
      }, 10);
    }

    summary.addEventListener("click", (event) => {
      event.preventDefault();

      if (element.classList.contains(IS_OPENED_CLASS)) {
        // アコーディオンを閉じる
        closeAccordion(element);
      } else {
        // 他の開いているアコーディオンを閉じる（排他処理）
        details.forEach((otherElement) => {
          if (otherElement !== element && otherElement.classList.contains(IS_OPENED_CLASS)) {
            closeAccordion(otherElement);
          }
        });

        // アコーディオンを開く
        element.classList.add(IS_OPENED_CLASS);
        element.setAttribute("open", "true");

        content.style.height = "0";
        content.style.opacity = "0";

        // scrollHeightを取得することでリフローが発生し、height:0が確定する
        const contentHeight = content.scrollHeight;

        content.style.height = contentHeight + "px";
        content.style.opacity = "1";

        content.addEventListener("transitionend", function handler(e) {
          if (e.propertyName === "height") {
            content.style.height = "auto";
            content.removeEventListener("transitionend", handler);
          }
        });
      }
    });
  });
};

// caution.php(「入力に関してのご注意」ページ)
const setUpCautionAccordion = () => {
  const details = document.querySelectorAll(".p-caution__content");
  const IS_OPENED_CLASS = "is-opened";

  details.forEach((element) => {
    const summary = element.querySelector(".p-caution__contentHead");
    const content = element.querySelector(".p-caution__contentBody");

    summary.addEventListener("click", (event) => {
      event.preventDefault();

      if (element.classList.contains(IS_OPENED_CLASS)) {
        // アコーディオンを閉じる
        element.classList.remove(IS_OPENED_CLASS);
        content.style.height = content.scrollHeight + "px";
        content.offsetHeight; // 強制リフロー
        content.style.height = "0";
        content.style.opacity = "0";

        content.addEventListener("transitionend", function handler(e) {
          if (e.propertyName === "height") {
            element.removeAttribute("open");
            content.removeEventListener("transitionend", handler);
          }
        });
      } else {
        // アコーディオンを開く
        element.classList.add(IS_OPENED_CLASS);
        element.setAttribute("open", "true");
        content.style.height = "0";
        content.style.opacity = "0";

        const contentHeight = content.scrollHeight;
        content.style.height = contentHeight + "px";
        content.style.opacity = "1";
        content.addEventListener("transitionend", function handler(e) {
          if (e.propertyName === "height") {
            content.style.height = "auto";
            content.removeEventListener("transitionend", handler);
          }
        });
      }
    });
  });
};
